import { handleAuthorization, handleOkResponseJson, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterPlanosManutencaoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PlanoManutencao/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterPlanosEquipamentoAsync = async (idEquipamento) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PlanoManutencao/obterListaPorEquipamento/` + idEquipamento, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarPlanoManutencaoAsync = async (descricao, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao: normalizeTextUppercase(descricao), itens })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PlanoManutencao`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}

export const editarPlanoManutencaoAsync = async (payload, origem = 'plano-manutencao-editar:salvar') => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + obterToken(),
            'X-Component-Action': origem
        },
        body: JSON.stringify({
            ...payload,
            descricao: normalizeTextUppercase(payload.descricao)
        })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PlanoManutencao/atualizar`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}

export const atualizarPlanoManutencaoEquipamentoAsync = async (idPlano, equipamentos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify(equipamentos.map(item => ({
            idEquipamento: item.idEquipamento
        })))
    };
    return apiFetch(
        `${process.env.VUE_APP_API_URL}/PlanoManutencao/atualizarEquipamento/` + idPlano,
        requestOptions,
        60000
    );
}

